export class RestoreGoogleWorkspaceMailRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "files",
            "baseName": "files",
            "type": "Array<FilePath>",
            "format": ""
        },
        {
            "name": "selection",
            "baseName": "selection",
            "type": "WorkspaceRestoreSelection",
            "format": ""
        },
        {
            "name": "restoreTargetMailboxes",
            "baseName": "restoreTargetMailboxes",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "restoreTargetLabel",
            "baseName": "restoreTargetLabel",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreOriginalLabels",
            "baseName": "restoreOriginalLabels",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGoogleWorkspaceMailRequest.attributeTypeMap;
    }
    constructor() {
    }
}
